import React, { Component } from 'react';
import './Graficos.css';
import {PieChart, Legend, BarChart} from 'react-easy-chart';
import { getData } from './Data.js'
import RemoveModal from './RemoveModal.js'
import AddModal from './AddModal.js'
import {Col, Card, Row } from 'react-materialize';
import AuthService from '../services/AuthService';
import { Redirect } from 'react-router-dom';

class Graficos extends Component {
	constructor(props){
		super(props);
		this.Auth = new AuthService();
		
		this.state = {
			graphCards: [],
			graphs: [],
			graphType: 'Pizza',
			dataType: 'IMC',
			redirect: false,
			configIMC: [
				{color: '#528DC3'},
				{color: '#00B050'},
				{color: '#FFC000'},
				{color: '#FF0000'},
				{color: '#FF00FF'},
				{color: '#FF8C00'},
				{color: '#0000FF'}
			],
			configAltura: [
				{color: "#A0C3E3"},
				{color: "#6299CB"},
				{color: "#2C74B0"},
				{color: "#2D539A"},
				{color: "#1D3866"}
			],
			configIdade: [
				{color: "#A8D18D"},
				{color: "#7FBB58"},
				{color: "#568034"},
				{color: "#487032"},
				{color: "#395723"}
			],
			config: [
				{color: '#FF4F4F'},
				{color: '#FF3B3B'},
				{color: '#FF0101'},
				{color: '#EA0000'},
				{color: '#D20000'},
				{color: '#B90000'},
				{color: '#860000'}
			]
		}
		
	}	

	componentWillReceiveProps(nextProps){
		if(nextProps.usuarios[0] && nextProps.usuarios !== this.props.usuarios){
			this.Auth.getPreferences().then((res) => {
				let vida = [];
				res.map((graph) => {
					if(graph){
						this.startGraphs(graph);
						vida.push(graph);
						return graph
					}
				})
				this.setState({graphs: vida})
			});
		}
	}

	componentWillMount() {
		this.getWindow();
	}

	getWindow() {

		var tamWidth = window.innerWidth;

		return tamWidth
	}

	arrangeUsers(name, titulo){
		if(titulo === 'IMC'){
			this.props.changeIndicador(titulo)
			this.props.arrange(name)
		}else if(titulo === 'Peso'){
			this.props.changeIndicador(titulo)
			this.props.arrange(name)
		}
		this.setState({redirect: true})
	}

	setPieLegenda(data, legenda) {
		let pieData = [];
		for(let i = 0; i < legenda.length; i++){
			pieData.push({key: legenda[i], value: data[i], color: this.state.config[i]})
		}

		return pieData;
	}


	startGraphs({dataType, graphType}) {
		const temp = getData(this.props.usuarios, dataType)
		const data = temp[0]
		const legenda = temp[1]

		if (graphType === 'Pizza') {
			this.buildPieGraph(data, legenda, dataType);
		}

		else {
			this.buildBarGraph(data, legenda, dataType);
		}
	
	}


	createGraph() {
		const temp = getData(this.props.usuarios, this.state.dataType)
		const data = temp[0]
		const legenda = temp[1]
		var graphsTemp = this.state.graphs

		if (this.state.graphType === 'Pizza') {
			this.buildPieGraph(data, legenda, this.state.dataType);
		}else {
			this.buildBarGraph(data, legenda, this.state.dataType);
		}

		graphsTemp.push({dataType: this.state.dataType, graphType: this.state.graphType})

		this.setState({graphs: graphsTemp})
		this.Auth.setPreferences(graphsTemp)
	}

	buildPieGraph(data, legenda, titulo) {
		var dados = [];
		var graphCardsTemp = this.state.graphCards
		const pieData = this.setPieLegenda(data, legenda);
		//faz a legenda ocupar o mesmo espaço para cada uma das opções de grafico atuais
		const marginValue = (legenda.length === 4 ? -1 : legenda.length === 5 ? -6 : -11)
		const customStyle = {
			'.legend': {
				fontSize: '0.6em',
			},
			'.legend li': {
				marginBottom: marginValue,
			}
		}

		let config;

		if(titulo === 'IMC'){
			config = this.state.configIMC
		}else if(titulo === 'Peso'){
			config = this.state.config
		}else if(titulo === 'Altura'){
			config = this.state.configAltura
		}else{
			config = this.state.configIdade;
		}

		for(let i = 0; i < legenda.length; i++){
			dados.push({ key: data[i], value: data[i], name: legenda[i], color: config[i].color })
		}

		graphCardsTemp.push( 
			<div>
				<Col l={6} m={12} s={12}>
					<Card className='card' textClassName='black-text'>
						<Row className='flex-container'>
							<Col l={6}>
								<span className='tituloGrafico'>{titulo}</span>
							</Col>
							<Col l={6} offset='l4'>
								<Legend data={pieData} dataId={'key'} config={config} styles={customStyle} />
							</Col>
						</Row>
						<Row>
							<Col l={8} m={11} s={12} className='flex-container-graph'>
								<PieChart labels padding={0} size={150} data={dados}
									clickHandler={
										(d) => this.arrangeUsers(d.data.name, titulo)
									}
								/>
							</Col>
							<Col l={4} m={5} s={12} className='flex-botao' >
								<RemoveModal index={graphCardsTemp.length} apaga={(index) => this.apagaGrafico(index)} />
							</Col>
						</Row>
					</Card>
				</Col>
			</div>
		)

		this.setState({graphCards: graphCardsTemp})

	}

	buildBarGraph(barData, legenda, titulo) {
		var dados = [];
		var graphCardsTemp = this.state.graphCards
		const pieData = this.setPieLegenda(barData, legenda);

		const marginValue = (legenda.length === 4 ? -1 : legenda.length === 5 ? -6 : -11)
		const customStyle = {
			'.legend': {
				fontSize: '0.6em',
			},
			'.legend li': {
				marginBottom: marginValue,
			}
		}

		let config;

		if(titulo === 'IMC'){
			config = this.state.configIMC
		}else if(titulo === 'Peso'){
			config = this.state.config
		}else if(titulo === 'Altura'){
			config = this.state.configAltura
		}else{
			config = this.state.configIdade;
		}

		for(let i = 0; i < legenda.length; i++){
			let label = '';
			for(let x = 0; x < i; x++)  label += '.'
			dados.push({ x: label, y: barData[i], color: config[i].color })
		}

		graphCardsTemp.push( 
			<div>
				<Col l={6} m={12} s={12}>
					<Card className='card' textClassName='black-text'>
						<Row className="flex-container-2" >
							<Col l={6} m={6} s={6}>
								<span className='tituloGrafico'>{titulo}</span>
							</Col>
							<Col l={4} m={6} s={6} offset='l2'>
								<Legend data={pieData} dataId={'key'} config={config} styles={customStyle} />
							</Col>
							<Col l={6} m={6} s={12} className='flex-container-barra'>
								<BarChart height={150} width={200}
									axisLabels={{x: 'My x Axis', y: 'My y Axis'}}
									axes
									data={dados}
									clickHandler={
										(d) => this.arrangeUsers(d.x, titulo)
									}
								/>
							</Col>
							<Col l={4} m={6} s={6} offset='l2' className="flex-botao" >
								<RemoveModal index={graphCardsTemp.length} apaga={(index) => this.apagaGrafico(index)} />
							</Col>
						</Row>
					</Card>
				</Col>
			</div>
		)
		this.setState({graphCards: graphCardsTemp})

	}


	apagaGrafico(index) {
		var graphCardsTemp = []
		graphCardsTemp = this.state.graphCards
		graphCardsTemp.splice(index, 1, graphCardsTemp[index+1])

		this.setState({graphCards: graphCardsTemp})

		var graphsTemp = this.state.graphs;
		graphsTemp.splice(index, 1, graphsTemp[index+1]);

		this.setState({graphs: graphsTemp})
		this.Auth.setPreferences(graphsTemp)
	}

	createAddCard(addCards) {
		if(this.state.redirect) this.setState({redirect: false})
		var cond = 0
		var graphCardsTemp = []

		graphCardsTemp = this.state.graphCards

		if (graphCardsTemp.length === 0) {
			cond = 4
		}

		else if (graphCardsTemp.length % 2 === 0) {
			cond = 2
		}

		else {
			cond = 3
		}

		for (var i = 0; i < cond; i++) {
			addCards.push(
				<Col key={i} l={6} m={12} s={12}>
					<Card className='card-add' textClassName='black-text'>
						<AddModal  create={() => this.createGraph()} data={(d) => this.setState({dataType: d})} type={(g) => this.setState({graphType: g})} />
					</Card>
				</Col>
			)

		}
		return(addCards)
	}




	render() {
		var addCards = [];

		return (
			<div>

				<Col s={12} l={7} m={12}  className="graficos">
					<div className="margem">
						{this.state.graphCards.map( (g, index) =>
							<div key={index} >
								{g}
							</div>
						)}
						{this.createAddCard(addCards)}
						{this.state.redirect && 
							<Redirect to='/home/' push/>
						}
					</div>
				</Col>
			</div>
		);
	}
}

export default Graficos;



// WEBPACK FOOTER //
// ./src/components/Graficos.js